import { createSlice, createSelector } from 'redux-starter-kit';
import Auth from '../repositories/Auth';
import { enqueueSnackbar } from './notifications';

const authSlice = createSlice({
  slice: 'auth',
  initialState: {
    loading: false,
    loginStatus: false,
    data: {},
    accounts: [],
    error: '',
    success: '',
  },
  reducers: {
    login: (state, action) => {
      state.loading = true;
      state.error = '';
      state.success = '';
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.error = '';
      state.loginStatus = true;
      state.data = action.payload.data;
      state.success = 'Login Successful! Welcome home! :D';
    },
    loginFailed: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.success = '';
    },

    addAcount: (state, action) => {
      state.loading = true;
      state.error = '';
      state.success = '';
    },
    addAcountSuccess: (state, action) => {
      state.loading = false;
      state.error = '';
      state.accounts = state.accounts.filter(acc => acc.id !== action.payload.data.id);
      state.accounts.push(action.payload.data);
      state.success = 'Account added succesfully!';
    },
    addAcountFailed: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.success = '';
    },

    swithAccount: (state, action) => {
      state.loading = false;
      state.error = '';
      state.success = 'Account switched!';
      state.accounts = state.accounts.filter(acc => acc.id !== action.payload.id);
      state.accounts.push(state.data);
      state.data = action.payload;
      localStorage.setItem('happihub_merchant_id', state.data.id);
      localStorage.setItem('happihub_merchant_token', state.data.token);
    },

    removeAccount: (state, action) => {
      state.accounts = state.accounts.filter(acc => acc.id !== action.payload);
      state.success = 'Account removed successfully!';
    },

    logout: (state, action) => {
      state.loginStatus = false;
      state.data = {};
      state.accounts = [];
      state.error = '';
      state.success = '';
    },
  },
});

// Extract the action creators object and the reducer
export const { actions, reducer } = authSlice;

export const selectors = {
  getAuth: createSelector(
    state => state.auth,
    data => data,
  ),
};

export const login = values => async (dispatch, getState) => {
  dispatch(actions.login());
  try {
    const response = await Auth.login(values);
    if (response.success) {
      localStorage.setItem('happihub_merchant_id', response.data.id);
      localStorage.setItem('happihub_merchant_token', response.data.token);
      dispatch(actions.loginSuccess(response));
    } else {
      throw Error(response.errMgs ? response.errMgs : 'Login Failed');
    }
  } catch (error) {
    console.log(error);
    dispatch(actions.loginFailed(error.message));
  }
};

export const addAcount = values => async (dispatch, getState) => {
  dispatch(actions.addAcount());
  try {
    const response = await Auth.login(values);
    if (response.success) {
      dispatch(actions.addAcountSuccess(response));
      dispatch(
        enqueueSnackbar({
          message: 'Account added successfully.',
          options: {
            key: new Date().getTime() + Math.random(),
            variant: 'success',
          },
        }),
      );
    } else {
      throw Error(response.errMgs ? response.errMgs : 'Login Failed');
    }
  } catch (error) {
    console.log(error);
    dispatch(actions.addAcountFailed(error.message));
    dispatch(
      enqueueSnackbar({
        message: 'Account add failed.',
        options: {
          key: new Date().getTime() + Math.random(),
          variant: 'success',
        },
      }),
    );
  }
};

// Export the reducer, either as a default or named export
export default reducer;
